import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import { Navigate } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import { FeatureRoute, FEATURES } from 'context/FeatureContext';
import React from 'react';
// render - dashboard
const Report = Loadable(lazy(() => import('pages/Report')));

const Configuration = Loadable(lazy(() => import('pages/Configuration')));
const Customer = Loadable(lazy(() => import('pages/Customer')));
const Equipments = Loadable(lazy(() => import('pages/Equipments')));
const Equipment = Loadable(lazy(() => import('pages/Equipment')));
const CleanRoomSuites = Loadable(lazy(() => import('pages/CleanRoomSuites')));
const CleanRoomSuite = Loadable(lazy(() => import('pages/CleanRoomSuite')));
const CleanRoomReport = Loadable(lazy(() => import('pages/CleanRoomReport')));

const WorkOrders = Loadable(lazy(() => import('pages/WorkOrders')));
const WorkOrder = Loadable(lazy(() => import('pages/WorkOrder')));
const Service = Loadable(lazy(() => import('pages/Service')));
const QBTest = Loadable(lazy(() => import('pages/QBTest')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <WorkOrders />
    },
    {
      path: 'workOrder/:id',
      element: <WorkOrder />
    },
    {
      path: 'service/:id',
      element: <Service />
    },
    {
      path: 'report/:id',
      element: <Report />
    },
    {
      path: 'customer',
      element: <Customer />
    },
    {
      path: 'equipment',
      element: <Equipments />
    },
    {
      path: 'equipment/:id',
      element: <Equipment />
    },
    {
      path: 'cleanroom',
      element: (
        <FeatureRoute feature={FEATURES.CleanRoom}>
          <CleanRoomSuites />
        </FeatureRoute>
      )
    },
    {
      path: 'cleanroom/:id',
      element: (
        <FeatureRoute feature={FEATURES.CleanRoom}>
          <CleanRoomSuite />
        </FeatureRoute>
      )
    },
    {
      path: 'cleanroomreport/:id',
      element: (
        <FeatureRoute feature={FEATURES.CleanRoom}>
          <CleanRoomReport />
        </FeatureRoute>
      )
    },
    {
      path: 'configuration',
      element: <Configuration />
    },
    {
      path: 'QBTest',
      element: <QBTest />
    }
  ]
};

export default MainRoutes;
